export default __webpack_public_path__ + "static/media/pattern.42c3c5fe.png";